/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OccupationApiModel { 
    id: number;
    employerId: number;
    name: string;
    valid: boolean;
    allRiskFactorExam: boolean;
    occupationCodeId?: number | null;
}

